<template>
    <a-modal
      wrapClassName="customModal"
      v-model="showDelDialog"
      :title="delTitle"
      centered
      :width="400"
      destroyOnClose
      :maskClosable="false"
      @cancel="closeDialog"
    >
      <div class="del-dialog-body">
        <div class="tip-image">
            <img src="~@/assets/img/del_fail.png" alt="">
        </div>
        <div class="tip-text">{{ tipText }}</div>
      </div>
      <div slot="footer">
        <a-button type="primary" @click="closeDialog">确定</a-button>
      </div>
    </a-modal>
    
</template>

<script>
export default {
    props: {
        showDelFailDialogProp: {
            type: Boolean,
            default: false
        },
        delTitle: {
            type: String
        },
        tipText: {
            type: String
        }
    },
    watch: {
        showDelFailDialogProp(val, old) {
            this.showDelDialog = val
            if (val == true) {
            }
        }
    },
    data() {
        return {
            showDelDialog: false,
        }
    },
    methods: {
        closeDialog() {
            this.$emit("update:showDelFailDialogProp", false)   
        }
    }
}
</script>

<style lang="scss" scoped>
.del-dialog-body {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .tip-image {
        width: 120px;
        height: 120px;
        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }
    .tip-text {
        margin-top: 20px;
    }
}
::v-deep .ant-modal-body {
    padding: 24px 16px !important;
    min-height: 200px;
    border-bottom: 1px solid #e7e7e7;
}
::v-deep .ant-modal-footer {
    padding: 20px;
    border-top: none;
    text-align: center;
    .ant-btn {
        width: 108px;
        height: 38px;
        border: 1px solid #5F60D3;
        color: #5F60D3;
    }
    .ant-btn-primary {
        margin-left: 16px;
        background: #5F60D3;
        color: #fff;
    }
}
</style>